import { makeAutoObservable } from 'mobx';
import { Column } from '../../types/Column';

type ColumnsConfig = Record<string, Column[]>;

export class ColumnStore {
  columnsConfig: ColumnsConfig = {};

  constructor() {
    makeAutoObservable(this);
  }

  getColumns(tableKey: string, defaultColumns: Column[]): Column[] {
    if (this.columnsConfig[tableKey]) return this.columnsConfig[tableKey];
    else {
      this.setColumns(tableKey, defaultColumns);
      return defaultColumns;
    }
  }

  setColumns(tableKey: string, columns: Column[]) {
    this.columnsConfig[tableKey] = columns;
  }

  toggleColumn(tableKey: string, columnId: string) {
    const updated = this.getColumns(tableKey, []).map((col) =>
      col.id === columnId ? { ...col, isVisible: !col.isVisible } : col
    );
    this.setColumns(tableKey, updated);
  }

  toggleAll(tableKey: string, isVisible: boolean) {
    const updated = this.getColumns(tableKey, []).map((col) => ({
      ...col,
      isVisible,
    }));
    this.setColumns(tableKey, updated);
  }

  checkIfColumnIsVisible(tableKey: string, columnId: string) {
    return this.getColumns(tableKey, []).find((col) => col.id === columnId)
      ?.isVisible;
  }
}

export const columnStore = new ColumnStore();
